import { useCaseCompleteness } from '../../shared/hooks/useCaseCompleteness';
import styles from '../CaseBuilderEnhanced.module.css';

const STEP_LABELS = {
    overview: 'Overview',
    clinical: 'Clinical',
    blocks: 'Blocks',
    slides: 'Slides',
};

export default function CaseStepNav({ step, setStep, steps, doc }) {
    const completeness = useCaseCompleteness(doc);

    const stepMeta = (key) => {
        switch (key) {
            case 'slides':
                if (!completeness.slideCount) return null;
                if (completeness.releaseReady > 0) {
                    return `${completeness.releaseReady} ready`;
                }
                return `${completeness.completeCount}/${completeness.slideCount}`;
            default:
                return null;
        }
    };

    return (
        <nav className={styles.stepNav} aria-label="Case workspace steps">
            {steps.map((key) => {
                const meta = stepMeta(key);
                return (
                    <button
                        key={key}
                        type="button"
                        className={`${styles.stepTab} ${step === key ? styles.stepTabActive : ''}`}
                        onClick={() => setStep(key)}
                        aria-current={step === key ? 'step' : undefined}
                    >
                        {STEP_LABELS[key] || key}
                        {meta && <span className={styles.stepCount}>{meta}</span>}
                    </button>
                );
            })}
        </nav>
    );
}
